export enum PayAsYouGoStatus {
  NOT_SET = 'Not Set',
  EMAIL_VALIDATION = 'Email Validation',
  SUBSCRIPTION_INCOMPLETED = 'Subscription Incompleted',
  SUBSCRIPTION_COMPLETED = 'Subscription Completed',
  NOT_CONFIGURED = 'Not Configured - has a plan (stripe or custome), never used',
  NO_PLAN = 'No Plan',
  MANUAL_CONFIGURATION_REQUIRED = 'MANUAL_CONFIGURATION_REQUIRED',
}
